import { SmoothScrollToOptions } from './smooth-scroll.model';

export const defaultSmoothScrollOptions: SmoothScrollToOptions = {
  duration: 468,
  easing: {
    x1: 0.42,
    y1: 0,
    x2: 0.58,
    y2: 1
  }
};
